import { render, staticRenderFns } from "./travel.vue?vue&type=template&id=0e700a78&scoped=true&"
import script from "./travel.vue?vue&type=script&lang=js&"
export * from "./travel.vue?vue&type=script&lang=js&"
import style0 from "./travel.vue?vue&type=style&index=0&id=0e700a78&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e700a78",
  null
  
)

export default component.exports